import Styles from '../styles.module.scss';

import data from '../../../../data/brokers/featuresBrokers';

const BrokersFeaturesSection = () => (
  <div className={Styles['brokers-features-section']}>
    <div className={Styles.section}>
      <h2>More Features. More Value. Lower Prices.</h2>
      <div className={Styles['table-wrapper']}>
        <table>
          <thead>
            <tr>
              <th />
              <th>CityFALCON</th>
              <th>Incumbents</th>
              <th>Web Scrapers</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr className={Styles[item.class]} key={item.id}>
                <td>{item.title}</td>
                <td>
                  <span className={Styles[item.CityFALCON.class]}>{item.CityFALCON.text}</span>
                </td>
                <td>
                  <span className={Styles[item.Incumbents.class]}>{item.Incumbents.text}</span>
                </td>
                <td>
                  <span className={Styles[item.WebScrapers.class]}>{item.WebScrapers.text}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default BrokersFeaturesSection;
